import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import {
    getUsers,
    getJobpacks,
    setClickedEventSegment,
    setSelectedJobpackID
} from "./actions";
import { selectWeekCount } from "./selectors";
import { Transition, TransitionGroup } from "react-transition-group";
const DragSensorCell = styled.div`
    height: 100%;
    width: ${({ dayCount }) => (1 / dayCount) * 100}%;
    background: white;
    position: absolute;
    border: 1px solid lightgrey;
    transition: all ${props => props.duration}ms ease-in-out;
    box-sizing: border-box;
    &.${props => props.className} {
        transform: translate(
            ${({ dayCount, cellIndex }) => cellIndex * 100}%,
            0
        );
        opacity: ${props => (props.className === "entered" ? 1 : 0)};
    }
`;

class DragSensorCellRow extends React.Component {
    render() {
        const dayCount = this.props.weekCount * 7;
        return (
            <TransitionGroup component={null}>
                {Array(dayCount)
                    .fill(true)
                    .map((e, i) => {
                        return (
                            <Transition
                                key={i}
                                appear
                                timeout={this.props.duration}
                            >
                                {transitionStatus => {
                                    return (
                                        <DragSensorCell
                                            cellIndex={i}
                                            dayCount={dayCount}
                                            className={transitionStatus}
                                            duration={this.props.duration}
                                            onDragOver={e =>
                                                this.props.onDragOver(
                                                    e,
                                                    i,
                                                    this.props.rowIndex
                                                )
                                            }
                                            onClick={() => {
                                                this.props.setClickedEventSegment(
                                                    false
                                                );
                                                this.props.setSelectedJobpackID(
                                                    false
                                                );
                                            }}
                                        />
                                    );
                                }}
                            </Transition>
                        );
                    })}
            </TransitionGroup>
        );
    }
}

export default hot(module)(
    React.memo(
        connect(
            store => {
                return {
                    weekCount: selectWeekCount(store)
                };
            },
            {
                getUsers,
                getJobpacks,
                setClickedEventSegment,
                setSelectedJobpackID
            }
        )(DragSensorCellRow)
    )
);
